import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import HighlightContainer from './Common/HighlightContainer';

const useStyles = makeStyles((theme) => ({
    text: {
        fontSize: '0.875rem',
        color: theme.palette.common.darkGrey,
        lineHeight: 1.5,
    },
}));

const NonBookableAlert = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <HighlightContainer>
            <Typography className={classes.text}>{t('NonBookableAppointmentMessage')}</Typography>
        </HighlightContainer>
    );
};

export default NonBookableAlert;
